const actions = {
    FETCH_RESULT_PUBLICATIONS: 'FETCH_RESULT_PUBLICATIONS',
    FETCH_RESULT_PUBLICATION: 'FETCH_RESULT_PUBLICATION',
    RESET_RESULT_PUBLICATION: 'RESET_RESULT_PUBLICATION',

    /** Fetch paginated Result Publications */
    fetchResultPublicationsAction: (data) => {
        return {
            type: actions.FETCH_RESULT_PUBLICATIONS,
            data: data
        };
    },

    /** Fetch single Result Publication */
    fetchResultPublicationAction: (data) => {
        return {
            type: actions.FETCH_RESULT_PUBLICATION,
            data: data
        };
    },

    /** Reset Result Publication Form */
    resetResultPublicationFormAction: () => {
        return {
            type: actions.RESET_RESULT_PUBLICATION,
            data: null
        };
    },
};

export default actions;